import { deepEqual, omit } from '@core/utils-legacy';

export const profileFieldNameEdited = (oldValue?: string, newValue?: string): boolean => {
  if (newValue === undefined) {
    return false;
  }

  return oldValue?.trim().toLowerCase() !== newValue!.trim().toLowerCase();
};

export const profileFieldValueEdited = (
  oldValue: Array<Record<string, unknown>>,
  newValue: Array<Record<string, unknown>>,
  omitProp?: string,
): boolean => {
  if (oldValue.length !== newValue.length) {
    return true;
  }

  const oldValuesWithOmittedProps = oldValue.map(value =>
    omitProp ? omit(value, omitProp) : value,
  );
  const newValuesWithOmittedProps = newValue.map(value =>
    omitProp ? omit(value, omitProp) : value,
  );
  return !deepEqual(oldValuesWithOmittedProps, newValuesWithOmittedProps);
};
